import "flag-icons/css/flag-icons.min.css";
import "leaflet/dist/leaflet.css";
import "./App.css";

import {
  AppTitleManager,
  AuthProvider,
  Header,
  msalConfig,
  NotFoundPage,
  RegistrationGuard,
  useSelectedSitesQuerySync,
} from "@abb-connect/react-shared";
import { createStandardPublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import HomePage from "@pages/HomePage";
import SitePage from "@pages/SitePage";
import { buildServicesUrl } from "@services/routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useParams,
} from "react-router";

const msalClientApplication =
  await createStandardPublicClientApplication(msalConfig);

const queryClient = new QueryClient();

const SERVICE_TITLE = import.meta.env.VITE_MODULE_NAME;
const HOME_PATHS = ["/"];

function Layout() {
  useSelectedSitesQuerySync({ clearSelectedOnPaths: HOME_PATHS });

  return (
    <>
      <AppTitleManager serviceTitle={SERVICE_TITLE} />
      <Header
        showServiceDropdown={false}
        mode="landingPage"
        getSiteUrl={({ site }) => buildServicesUrl([site])}
        getMultiSiteUrl={buildServicesUrl}
      />
      <RegistrationGuard>
        <Outlet />
      </RegistrationGuard>
    </>
  );
}

// Redirects legacy /site/:site links to the new /services location.
function LegacySiteRedirect() {
  const { site } = useParams();
  return <Navigate to={`/services?sites=${site}`} replace />;
}

function App() {
  return (
    <MsalProvider instance={msalClientApplication}>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="services" element={<SitePage />} />
                <Route path="site/:site" element={<LegacySiteRedirect />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </QueryClientProvider>
      </AuthProvider>
    </MsalProvider>
  );
}

export default App;
